import React, { useState, useEffect } from "react";
import axios from "axios"; // Using axios for data fetching
import { getNewsletterEmails } from "../reduxData/user/userAction";

const EmailUsers = () => {
  const [emails, setEmails] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [copyText, setCopyText] = useState("Copy to Clipboard");

  useEffect(() => {
    const fetchEmails = async () => {
      try {
        const response = await getNewsletterEmails()
        console.log(response)
        setEmails(response|| []);
      } catch (err) {
        setError("Failed to fetch emails. Please try again later.");
        console.error(err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchEmails();
  }, []);

  const handleCopy = () => {
    const emailString = emails.join(", ");
    navigator.clipboard.writeText(emailString).then(() => {
      setCopyText("Copied!");
      setTimeout(() => setCopyText("Copy to Clipboard"), 2000); 
    });
  };

  const handleDownload = (format) => {
    let content = "";
    let mimeType = "";
    let filename = "";

    if (format === "txt") {
      content = emails.join("\n");
      mimeType = "text/plain";
      filename = "emails.txt";
    } else if (format === "csv") {
      content = "email\n" + emails.join("\n");
      mimeType = "text/csv;charset=utf-8;";
      filename = "emails.csv";
    }

    const blob = new Blob([content], { type: mimeType });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const renderContent = () => {
    if (isLoading) {
      return <p>Loading emails...</p>;
    }
    if (error) {
      return <p className="text-danger">{error}</p>;
    }
    if (emails.length === 0) {
      return <p>No emails found in the newsletter list.</p>;
    }
    return (
      <>
        <textarea
          className="form-control"
          rows="10"
          readOnly
          value={emails.join(", ")}
        />
        <div className="mt-3">
          <button className="btn btn-warning me-2" onClick={handleCopy}>
            {copyText}
          </button>
          <button className="btn btn-secondary me-2" onClick={() => handleDownload("txt")}>
            Download as .txt
          </button>
          <button className="btn btn-secondary" onClick={() => handleDownload("csv")}>
            Download as .csv
          </button>
        </div>
      </>
    );
  };

  return (
    <div className="container mt-4">
      <div className="card">
        <div className="card-header d-flex justify-content-between align-items-center">
          <h2>Newsletter Subscribers</h2>
          <span className="badge bg-warning rounded-pill" style={{ color: 'black'}}>{emails.length} Emails</span>
        </div>
        <div className="card-body">
            {renderContent()}
        </div>
      </div>
    </div>
  );
};

export default EmailUsers;